/* eslint-disable max-len */
import { CONTENT } from '@bitComponents/unifiedComponents/Stopper';
import {
  BUTTON_WIDTH,
  BUTTON_HEIGHT,
  BUTTON_COLOR,
} from '@bitComponents/unifiedComponents/Button';
import { USER_TYPE } from '../../../../bitConstants/constants';
import { CALL_GENERIC_900, DEBT_PAYMENT, ONBOARDING_PROCESS, PHONE_900, URLS } from '../../errorTextsConstants';

export const getErrorToPrint = ( goToC2C ) => {
  return {
    common: {
      PRODUCT_REGISTERED: {
        errorType: CONTENT.INFO_ALERT,
        errorInfo: {
          title: 'La oferta del {device} ha cambiado',
          msg: ['Ya añadiste un dispositivo con precio exclusivo a tu pack:', '{includedR2RInfo}' , 'Por este motivo, las ofertas disponibles para ti son diferentes. Revisa el precio del dispositivo {device} o consulta otros dispositivos.'],
          buttons: [{
            color: BUTTON_COLOR.BLUE,
            link: `${URLS.URL_PACKS}&origin=pyp-ver-ofertas`,
            label: 'Continuar',
            desktopProps: {
              size: {
                w: BUTTON_WIDTH.LIQUID_DOPPED,
                h: BUTTON_HEIGHT.REGULAR,
              },
            },
          }],
          errorName: 'producto ya en parque',
        },
      },
      NON_FUSION_CURRENT_PORTFOLIO: {
        errorType: CONTENT.ERROR_ALERT,
        errorInfo: {
          title: 'Lo sentimos, no podemos ofrecerte este dispositivo',
          msg: [
            'Para añadir este dispositivo es necesario contratar un pack miMovistar.',
            'Si lo prefieres, descubre nuestra oferta de dispositivos libres.',
          ],
          buttons: [{
            color: BUTTON_COLOR.BLUE,
            link: URLS.VTL_CATALOG,
            label: 'Ir a móviles y electrónica',
            desktopProps: {
              size: {
                w: BUTTON_WIDTH.LIQUID_DOPPED,
                h: BUTTON_HEIGHT.REGULAR,
              },
            },
          },
          {
            color: BUTTON_COLOR.BLUE_REVERSE,
            link: URLS.PACK_CONFIG,
            label: 'Configura tu pack',
            desktopProps: {
              size: {
                w: BUTTON_WIDTH.LIQUID_DOPPED,
                h: BUTTON_HEIGHT.REGULAR,
              },
            },
          }],
          errorName: 'producto no compatible / tapon legado',
        },
      },
      ADDITIONAL_R2R_ERROR: {
        errorType: CONTENT.INFO_ALERT,
        errorInfo: {
          title: 'Todavía no has solicitado tu dispositivo incluido a un precio especial',
          msg: [
            'Descubre la oferta disponible para ti',
          ],
          buttons: [{
            color: BUTTON_COLOR.BLUE,
            link: URLS.VTL_CATALOG,
            label: 'Ir a móviles y electrónica',
            desktopProps: {
              size: {
                w: BUTTON_WIDTH.LIQUID_DOPPED,
                h: BUTTON_HEIGHT.REGULAR,
              },
            },
          }],
          errorName: 'producto r2r adicional no disponible',
        },
      },
      SIGNATURE_IFRAME_ERROR: {
        errorType: CONTENT.ERROR_ALERT,
        errorInfo: {
          title: 'Upss… algo ha ido mal',
          msg: [
            'No podemos generar tu pedido en estos momentos.',
            'Por favor, inténtalo más tarde o llámanos gratis al 900 104 430.',
            'Sentimos las molestias ocasionadas.',
          ],
          buttons: [{
            link: URLS.VTL_CATALOG,
            label: 'Volver a móviles y electrónica',
            desktopProps: {
              size: {
                w: BUTTON_WIDTH.LIQUID_DOPPED,
                h: BUTTON_HEIGHT.REGULAR,
              },
            },
            color: BUTTON_COLOR.BLUE,
          }],
          errorName: 'error generico',
        },
      },
      BLOCKED_USER: {
        errorType: CONTENT.ERROR_ALERT,
        errorInfo: {
          title: 'Recogida en tienda del dispositivo',
          msg: [
            'Por seguridad la recogida y firma del contrato de arrendamiento del dispositivo en el caso de autónomos debe realizarse en una tienda Movistar para validar tu identidad.',
            'Si lo deseas, puedes pedir una cita previa en tienda para realizarlo.',
          ],
          buttons: [
            {
              color: BUTTON_COLOR.BLUE,
              onClick: () => {
                window.location.href = URLS.BOOK_SHOP_APPOINTMENT;
              },
              label: 'Solicitar cita previa',
              desktopProps: {
                size: {
                  w: BUTTON_WIDTH.MEDIUM,
                  h: BUTTON_HEIGHT.REGULAR,
                },
              },
            },
          ],
          errorName: 'cif user blocked',
        },
      },
      WITHOUT_REQUIRED_DATA_TO_SIGN: {
        errorType: CONTENT.ERROR_ALERT,
        errorInfo: {
          title: 'Upss… algo ha ido mal',
          msg: [
            'No podemos generar tu pedido en estos momentos.',
            'Por favor, inténtalo más tarde o llámanos gratis al 900 104 430.',
            'Sentimos las molestias ocasionadas.',
          ],
          buttons: [{
            link: URLS.VTL_CATALOG,
            label: 'Volver a móviles y electrónica',
            color: BUTTON_COLOR.BLUE,
            desktopProps: {
              size: {
                w: BUTTON_WIDTH.LIQUID_DOPPED,
                h: BUTTON_HEIGHT.REGULAR,
              },
            },
          }],
          errorName: 'sin telefono para firmar documento',
        },
      },
      WITHOUT_URL_TO_SIGN: {
        errorType: CONTENT.ERROR_ALERT,
        errorInfo: {
          title: 'Upss… algo ha ido mal',
          msg: [
            'No podemos generar tu pedido en estos momentos.',
            'Por favor, inténtalo más tarde o llámanos gratis al 900 104 430.',
            'Sentimos las molestias ocasionadas.',
          ],
          buttons: [{
            link: URLS.VTL_CATALOG,
            label: 'Volver a móviles y electrónica',
            color: BUTTON_COLOR.BLUE,
            desktopProps: {
              size: {
                w: BUTTON_WIDTH.LIQUID_DOPPED,
                h: BUTTON_HEIGHT.REGULAR,
              },
            },
          }],
          errorName: 'sin url para firmar',
        },
      },
      INSUFFICIENT_CREDIT_LIMIT: {
        errorType: CONTENT.INFO_ALERT,
        errorInfo: {
          buttons: [
            {
              color: BUTTON_COLOR.BLUE,
              link: URLS.VTL_CATALOG,
              label: "Ir a móviles y electrónica",
              desktopProps: {
                size: {
                  w: BUTTON_WIDTH.LIQUID_DOPPED,
                  h: BUTTON_HEIGHT.REGULAR,
                },
              },
            },
          ],
          title: "Lo sentimos, no podemos continuar con tu pedido",
          msg: ["Actualmente no podemos aplicarte esta promoción.","Consulta el listado de móviles y electrónica con las ofertas disponibles para ti."],
          errorName: "limite credito insuficiente",
        },
      },
      ONBOARDING_NEEDED: {
        errorType: CONTENT.INFO_ALERT,
        errorInfo: {
          // buttons: [
          //   ONBOARDING_PROCESS,
          // ],
          // title: "Lo sentimos, no podemos continuar con tu pedido",
          // msg: ["Para continuar con tu pedido es necesario que verifiques tu identidad."],
          buttons: [CALL_GENERIC_900],
          title: "Lo sentimos, no podemos continuar con tu pedido",
          msg: [`Llama al ${PHONE_900} y un asesor comercial te ayudará a resolverlo.`],
          errorName: "onboarding necesario ampliar limite credito",
        },
      },
      RISK_VALIDATION_UNAVAILABLE: {
        errorType: CONTENT.INFO_ALERT,
        errorInfo: {
          buttons: [{
            link: URLS.VTL_CATALOG,
            label: 'Volver a móviles y electrónica',
            color: BUTTON_COLOR.BLUE,
            desktopProps: {
              size: {
                w: BUTTON_WIDTH.LIQUID_DOPPED,
                h: BUTTON_HEIGHT.REGULAR,
              },
            },
          }],
        },
      },
    },
    [`user_${USER_TYPE.TELCO}`]: {
    },
    [`user_${USER_TYPE.OPEN}`]: {
    },
  }
};
